import { FormControl, FormErrorMessage, Textarea } from "@chakra-ui/react";
import { Card } from "@components/ui-kit";
import { t } from "@lingui/macro";
import { observer } from "mobx-react-lite";
import { InvoiceTypeEnum, useInvoiceStore } from "../../../store";

export const NoteOnInvoiceCard = observer(function NoteOnInvoiceCard() {
  const store = useInvoiceStore();
  return (
    <Card sectioned>
      <h2 className="text-3xl font-semibold mb-8">
        {store.type === InvoiceTypeEnum.CreditNote
          ? t`Note on credit note`
          : t`Note on invoice`}
      </h2>
      <FormControl isInvalid={store.form.note.hasError}>
        <Textarea
          onChange={(event) => store.form.note.onChange(event.target.value)}
          placeholder={
            store.type === InvoiceTypeEnum.CreditNote
              ? t`Note on credit note`
              : t`Note on invoice`
          }
          rows={2}
          value={store.form.note.value}
        />
        <FormErrorMessage>{store.form.note.error}</FormErrorMessage>
      </FormControl>
    </Card>
  );
});
